import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import bin from '../../../images/bin.svg';
import ReactHtmlParser from 'react-html-parser';

const Delete = ({ onClick, disabled, tooltipText }) => {
    const { t } = useTranslation();

    const clb = onClick ? onClick : () => {};
    const className = `action-icon ${disabled ? 'disabled' : null}`;

    return (
        <>
            <OverlayTrigger
                placement="top"
                overlay={props => (
                    <Tooltip {...props}>
                        <div>{t('reports.delete.tooltip')}</div>
                        <div>{ReactHtmlParser(tooltipText)}</div>
                    </Tooltip>
                )}
            >
                <img src={bin} alt="delete" className={className} onClick={clb} />
            </OverlayTrigger>
        </>
    );
};

export default Delete;
